import dedent from './dedent';

export default {
  key: 'gtm',
  lang: 'html',
  generate: ({ webWidgetScript }) =>
    [
      '<!-- 1. In Google Tag Manager, click Tags > New, then choose Custom HTML. -->',
      '<!-- 2. Paste the code below into the HTML field. -->',
      '<!-- 3. Set the trigger to All Pages, save the tag, then Submit and Publish. -->',
      dedent(webWidgetScript),
    ].join('\n'),
};
